import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Employee } from '../../../models/employee';
import { EmployeeListService } from '../../../services/employee-list.service';
import { PdfService } from '../../../services/pdf.service';
import { distinctUntilChanged, map } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { findEmployeeAct } from '../../../store/employee/employee.actions';

@Component({
  selector: 'app-employ-detail',
  standalone: false,
  templateUrl: './employ-detail.component.html',
  styleUrl: './employ-detail.component.css'
})
export class EmployDetailComponent {
  employee: Employee = new Employee();
  loading = true;
  private pdfService = inject(PdfService);

  salaryColumns: string[] = ['salary','initDate','endDate']; //,'obs'];
  //positionColumns: string[] = ['position','initDate','endDate']; //,'obs'];

  constructor(
    private route: ActivatedRoute,
    private employeeStore: Store<{employeeRdc: any}>
  ) {

    this.employeeStore.pipe(
      select('employeeRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        employee: state.employee, // revisar
        //violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ employee, loading }) => {
      this.employee = employee;
      //this.violations = violations;
      this.loading = loading;
    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.employeeStore.dispatch(findEmployeeAct({ id }));
      }else{
        this.employee = new Employee();
        this.loading = false;
      }
    });
  }

  getAge(birthDate: Date | string): number {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  }

  imprimirCarta(letter: string): void {
    this.loading = true;
    this.pdfService.printLettersForEmployee(this.employee.id, letter).subscribe((response: Blob) => {
      const fileURL = URL.createObjectURL(response);
      this.loading = false;
      window.open(fileURL, '_blank');
    });
  }
}
